// Old parking slugs (e.g. already printed or shared) mapped to the slug they should resolve to.
// Used by NotFoundPage (short links) and the QR code flow (camera scan and manual entry).
export const PARKING_SLUG_ALIASES: ReadonlyMap<string, string> = new Map([['TMP-owdH', 'BYD-S3DC']]);
